import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { DateRangeType } from "../../common/enums/DRCXEnums";
import { IeLynxObject } from "../../common/models/eLynxObject";


export const devInfoEmail = "devinfo@elynxtech.com";    
export const hiddenRecipients: string[] = [devInfoEmail, "reports@elynxtech.com"];


export enum ReportScheduleTypeSelectionEnum {
    All = 0,
    User = 1,
    GroupMarketing = 2,
    Custom = 3,
    //QuickTrend = 4,
}

export enum ReportTypeEnum {
    None = -1,
    Unspecified = 0,
    User = 1,
    GroupMarketing = 2,
    Custom = 3,
    //QuickTrend = 4
}

export enum ExportFormatTypeEnum {
    Other = -1,
    Excel = 0,
    //ExcelTemplate = 1,
    Csv = 2,
    //Xml = 3,
    Pdf = 4,
    //Tsv = 5,
    //QuickTrend = 6,
    Custom = 7,
    Excel2007 = 8,
}

export enum ReportDeliveryType {
    //Ftp = 1,
    Email = 2,
    //TextMsg = 3,
    //SavedReport = 4,
    NotificationList = 5
}

export interface IEditReportTaskDTO {
    id?: number;
    name?: string;
    reportConfigId?: number;
    exportFormat: ExportFormatTypeEnum;
    reportType: ReportTypeEnum;
    organizationId?: number;
    overrideGroupId?: number;
    overrideTatId?: number;
    timezoneIndex?: number;
    description?: string;

    deliveries?: Array<IEditReportDeliveryDTO>;
    schedules?: Array<IEditReportScheduleDTO>;
    isMyReports?: boolean;
    isAdminView?: boolean;
}

export interface IEditReportDeliveryDTO {
    id?: number;
    emailSubject?: string;
    emailBody?: string;
    address?: string;
    deliveryType?: ReportDeliveryType;
    ftpInfo?: IEditReportFTPInfoDTO;
    isModified?: boolean;
    isDeleted?: boolean;
    fullDisplayText?: string;

    selected?: boolean;
}

// TODO: Support for FTP deliveries is not currently implemented
export interface IEditReportFTPInfoDTO {
    id?: number;
}

export interface IEditReportScheduleDTO {
    id: number;    
    description?: string;
    lastRunTime?: Date;
    nextScheduledTime?: Date;
    repeatRange?: DateRangeType;
    repeatInterval?: number;
    timezoneIndex?: number;
    startTime?: Date;
    endTime?: Date;
    isActive?: boolean;
    isAdHoc?: boolean;
    dayOfMonth?: number;
    dayOfWeek?: number;
    hour?: number;
    minute?: number;
    isModified?: boolean;
    isDeleted?: boolean;
    isCustom?: boolean;
}

export interface IScheduledReportSummaryDTO {
    id: number;
    name: string;
    lastRun: Date;
    createdBy: string;
    reportName: string;
    type: ReportTypeEnum;

    /*Display properties*/
    lastRunDisplay: string;
}

export interface IReportTaskSummaryDTO {
    id: number;
    name: string,
    lastRun: Date;
    configCreatedBy: IeLynxObject;
    taskCreatedBy: IeLynxObject;
    reportName: string;
    type: ReportTypeEnum;
    schedules: Array<IReportScheduleSummaryDTO>;
    notifications: Array<IReportNotificationSummaryDTO>;
    groupId: number;
    groupPath: string;

    areNotificationsExpanded: boolean;
    notificationCount: number;
    areSchedulesExpanded: boolean;    
    scheduleCount: number;
    emailNotifications: Array<IReportNotificationSummaryDTO>;
    notificationListNotifications: Array<IReportNotificationSummaryDTO>;
    canCopy: boolean;
    canDelete: boolean;
}

export interface IReportScheduleSummaryDTO {
    id: number;
    description: string;
    frequency: DateRangeType | number;
    repeatInterval: number;
    lastRunTime: Date;
    nextScheduledTime: Date;
    isActive: boolean;
    timezoneIndex: number;
    timezoneName: string;
    dayOfMonth: number;
    dayOfWeek: number;
    hour: number;
    minute: number;
    
    frequencyDisplay: string;
    lastRunDisplay: string;

    frequencyOption: DateRangeType;
}

export interface IReportNotificationSummaryDTO {
    id: number;
    deliveryType: ReportDeliveryType;
    displayText: string;

    selected?: boolean;
}

export interface IScheduledReportRestQueryParams {
    includeAdvancedIntervals?: boolean;
    includeInactiveSchedules?: boolean;
    organizationID?: number;


    isMyReports?: boolean;
}

export interface IScheduledReportConfigurationResults {
    taskId: number;
    taskChanged: boolean;
    taskRenamed: boolean;
    taskDeleted: boolean;
}

// export class EditReportTaskModel {
//     public static NEW_INSTANCE_ID: number = -1;

//     public id: number;
//     public name: string;
//     public reportConfigId?: number;
//     public exportFormat: ExportFormatTypeEnum;
//     public reportType: ReportTypeEnum;
//     public organizationId: number;
//     public overrideGroupId?: number;
//     public overrideTatId?: number;
//     public timezoneIndex: number;
//     public description: string;    

//     public deliveries: Array<EditReportDeliveryModel>;    
//     public schedules: Array<EditReportScheduleModel>;
//     public isMyReports: boolean;
//     public isAdminView: boolean;

//     constructor(dto?: IEditReportTaskDTO) {
//         if (dto) {
//             if (typeof dto.id !== "undefined") {
//                 this.id = dto.id;
//             }
//             if (typeof dto.name !== "undefined") {
//                 this.name = dto.name;
//             }
//             if (typeof dto.reportConfigId !== "undefined") {
//                 this.reportConfigId = dto.reportConfigId;
//             }
//             if (typeof dto.exportFormat !== "undefined") {
//                 this.exportFormat = dto.exportFormat;
//             }
//             if (typeof dto.reportType !== "undefined") {
//                 this.reportType = dto.reportType;
//             }
//             if (typeof dto.organizationId !== "undefined") {
//                 this.organizationId = dto.organizationId;
//             }
//             if (typeof dto.overrideGroupId !== "undefined") {
//                 this.overrideGroupId = dto.overrideGroupId;
//             }
//             if (typeof dto.overrideTatId !== "undefined") {
//                 this.overrideTatId = dto.overrideTatId;
//             }
//             if (typeof dto.timezoneIndex !== "undefined") {
//                 this.timezoneIndex = dto.timezoneIndex;
//             }
//             if (typeof dto.description !== "undefined") {
//                 this.description = dto.description;
//             }
//             if (typeof dto.deliveries !== "undefined") {
//                 this.deliveries = dto.deliveries
//                     ? dto.deliveries.map(
//                         r => new EditReportDeliveryModel(r)
//                     )
//                     : null;
//             }
//             if (typeof dto.schedules !== "undefined") {
//                 this.schedules = dto.schedules
//                     ? dto.schedules.map(
//                         r => new EditReportScheduleModel(r)
//                     )
//                     : null;
//             }
//             if (typeof dto.isMyReports !== "undefined") {
//                 this.isMyReports = dto.isMyReports;
//             }
//             if (typeof dto.isAdminView !== "undefined") {
//                 this.isAdminView = dto.isAdminView;
//             }
//         }
//     }

//     public toDTO(): IEditReportTaskDTO {
//         return {
//             id: this.id,
//             name: this.name,
//             reportConfigId: this.reportConfigId,
//             exportFormat: this.exportFormat,
//             reportType: this.reportType,
//             organizationId: this.organizationId,
//             overrideGroupId: this.overrideGroupId,
//             overrideTatId: this.overrideTatId,
//             timezoneIndex: this.timezoneIndex,
//             description: this.description,
//             deliveries: this.deliveries
//                 ? this.deliveries.map(model => model.toDTO())
//                 : this.deliveries,
//             schedules: this.schedules
//                 ? this.schedules.map(model => model.toDTO())
//                 : this.schedules,
//             isMyReports: this.isMyReports,
//             isAdminView: this.isAdminView
//         }
//     }

//     public toJSON(): any {
//         return this.toDTO();
//     }

//     public clone(): EditReportTaskModel {
//         return new EditReportTaskModel(this.toDTO());
//     }

//     public validate(): boolean {
//         return true;
//     }

//     public addRecipient(model: AvailableRecipient): void {
//         if (!Enumerable.from(this.deliveries).any((obj: EditReportDeliveryModel) => model.displayText && obj.equatableKey === model.displayText.toLowerCase())) {
//             const object: EditReportDeliveryModel = new EditReportDeliveryModel({
//                 id: EditReportDeliveryModel.NEW_INSTANCE_ID,
//                 address: model.displayText,
//                 deliveryType: ReportDeliveryType.Email
//             });
//             this.deliveries.push(object);
//         }
//     }

//     public removeRecipient(model: AvailableRecipient): void {
//         // Find the item
//         const itemToRemove = Enumerable
//             .from(this.deliveries)
//             .firstOrDefault((obj: EditReportDeliveryModel) => model.displayText && obj.equatableKey === model.displayText.toLowerCase());

//         if (itemToRemove) {
//             const index = this.deliveries.indexOf(itemToRemove);
//             if (index > -1) {
//                 this.deliveries.splice(index, 1);
//             }
//         }
//     }

//     public addNotificationList(model: AvailableNotificationList): void {        
//         if (!Enumerable.from(this.deliveries).any((obj: EditReportDeliveryModel) => Number(obj.address) === model.equatableKey)) {
//             const object: EditReportDeliveryModel = new EditReportDeliveryModel({
//                 id: EditReportDeliveryModel.NEW_INSTANCE_ID,                
//                 address: model.equatableKey.toString(), // Notification List Deliveries have the Notification List ID as the address.
//                 deliveryType: ReportDeliveryType.NotificationList,
//                 fullDisplayText: model.displayText
//             });
//             this.deliveries.push(object);
//         }
//     }

//     public removeNotificationList(model: AvailableNotificationList): void {
//         // Find the item
//         const itemToRemove = Enumerable
//             .from(this.deliveries)
//             .firstOrDefault((obj: EditReportDeliveryModel) => Number(obj.address) === model.equatableKey);

//         if (itemToRemove) {
//             const index = this.deliveries.indexOf(itemToRemove);
//             if (index > -1) {
//                 this.deliveries.splice(index, 1);
//             }
//         }
//     }
// }

// export class EditReportScheduleModel {
//     public static NEW_INSTANCE_ID = -1;
//     public id: number;    
//     public description: string;
//     public frequency: DRCX.DateRangeType;
//     public repeatInterval: number;
//     public repeatFrequency: number;
//     public lastRunTime: moment.Moment;
//     public nextScheduledTime: moment.Moment;
//     public timezoneIndex: number;
//     public startTime: moment.Moment;
//     public endTime: moment.Moment;
//     public isActive: boolean;
//     public isAdHoc: boolean;

//     public dayOfMonth: number;
//     public dayOfWeek: number;
//     public hour: number;
//     public minute: number;    
//     public selectedTimezoneLabel: string;
//     public selectedDayOfMonth: string = i18n.t("reportScheduleAdmin.steps.details.selectDayOfMonth");
//     public selectedDayOfWeek: string = i18n.t("reportScheduleAdmin.steps.details.selectDayOfWeek");
//     public selectedHour: string = i18n.t("reportScheduleAdmin.steps.details.selectHour");
//     public selectedMinute: string = i18n.t("reportScheduleAdmin.steps.details.selectMinute");
//     public isExpanded = false;
//     public isMenuVisible = false;
//     public isModified = false;
//     public isDeleted = false;
//     public isCustom = false;

//     public frequencySummary: string;

//     constructor(dto?: IEditReportScheduleDTO) {
//         if (dto) {
//             if (typeof dto.id !== "undefined") {
//                 this.id = dto.id;
//             }
//             if (typeof dto.description !== "undefined") {
//                 this.description = dto.description;
//             }
//             if (typeof dto.repeatRange !== "undefined") {
//                 this.frequency = dto.repeatRange;
//             }
//             if (typeof dto.repeatInterval !== "undefined") {
//                 this.repeatInterval = dto.repeatInterval;
//             }
//             if (typeof dto.lastRunTime !== "undefined") {
//                 this.lastRunTime = dto.lastRunTime;
//             }
//             if (typeof dto.nextScheduledTime !== "undefined") {
//                 this.nextScheduledTime = moment(dto.nextScheduledTime);
//             }
//             if (typeof dto.dayOfMonth !== "undefined") {
//                 this.dayOfMonth = dto.dayOfMonth;
//                 this.selectedDayOfMonth = this.dayOfMonth.toString();
//             }
//             if (typeof dto.dayOfWeek !== "undefined") {
//                 this.dayOfWeek = dto.dayOfWeek;
//                 this.selectedDayOfWeek = Enumerable.from(ReportScheduleAdminUtilties.getDayOfWeekOptions())
//                     .firstOrDefault(o => o.id === this.dayOfWeek).name;
//             }
//             if (typeof dto.hour !== "undefined") {
//                 this.hour = dto.hour;
//                 this.selectedHour = ReportScheduleAdminUtilties.leadingZeros(this.hour);
//             }
//             if (typeof dto.minute !== "undefined") {
//                 this.minute = dto.minute;
//                 this.selectedMinute = ReportScheduleAdminUtilties.leadingZeros(this.minute);
//             }
//             if (typeof dto.timezoneIndex !== "undefined") {
//                 this.timezoneIndex = dto.timezoneIndex;
//             }
//             if (typeof dto.startTime !== "undefined") {
//                 this.startTime = moment(dto.startTime);
//             }
//             if (typeof dto.endTime !== "undefined") {
//                 this.endTime = moment(dto.endTime);
//             }
//             if (typeof dto.isActive !== "undefined") {
//                 this.isActive = dto.isActive;
//             }
//             if (typeof dto.isAdHoc !== "undefined") {
//                 this.isAdHoc = dto.isAdHoc;
//             }
//             if (typeof dto.isDeleted !== "undefined") {
//                 this.isDeleted = dto.isDeleted;
//             }
//             if (typeof dto.isModified !== "undefined") {
//                 this.isModified = dto.isModified;
//             }            
//             this.isExpanded = true;
//         }
//     }

//     public toDTO(): IEditReportScheduleDTO {
//         return {
//             id: this.id,
//             description: this.description,
//             repeatRange: this.frequency,
//             repeatInterval: this.repeatInterval,
//             lastRunTime: this.lastRunTime,
//             nextScheduledTime: this.nextScheduledTime,
//             startTime: this.startTime,
//             endTime: this.endTime,
//             isActive: this.isActive,
//             isAdHoc: this.isAdHoc,
//             dayOfMonth: this.dayOfMonth,
//             dayOfWeek: this.dayOfWeek,
//             hour: this.hour,
//             minute: this.minute,
//             timezoneIndex: this.timezoneIndex,
//             isDeleted: this.isDeleted,
//             isModified: this.isModified,
//             isCustom: this.isCustom
//         };
//     }

//     public clone(): EditReportScheduleModel {
//         return new EditReportScheduleModel(this.toDTO());
//     }

//     public validate(): boolean {
//         if(this.frequency == DRCX.DateRangeType.Invalid && this.timezoneIndex > 0)
//             return false;
//         else if(this.frequency == 99 && this.repeatFrequency <= 0)
//             return false;
//         else return true;
//     }
// }

// export class EditReportDeliveryModel implements IEquatable<string> {
//     public static NEW_INSTANCE_ID = -1;
//     public id: number;
//     public emailSubject: string;
//     public emailBody: string;
//     public address: string;
//     public deliveryType: ReportDeliveryType;
//     public ftpInfo: EditReportFtpInfoModel;
//     public isModified = false;
//     public isDeleted = false;
//     public fullDisplayText: string;

//     public get equatableKey(): string {
//         return this.address
//             ? this.address.toLowerCase()
//             : null;
//     }

//     constructor(dto?: IEditReportDeliveryDTO) {
//         if (dto) {
//             if (typeof dto.id !== "undefined") {
//                 this.id = dto.id;
//             }
//             if (typeof dto.emailSubject !== "undefined") {
//                 this.emailSubject = dto.emailSubject;
//             }
//             if (typeof dto.emailBody !== "undefined") {
//                 this.emailBody = dto.emailBody;
//             }
//             if (typeof dto.address !== "undefined") {
//                 this.address = dto.address;
//             }
//             if (typeof dto.deliveryType !== "undefined") {
//                 this.deliveryType = dto.deliveryType;
//             }
//             if (typeof dto.isDeleted !== "undefined") {
//                 this.isDeleted = dto.isDeleted;
//             }
//             if (typeof dto.isModified !== "undefined") {
//                 this.isModified = dto.isModified;
//             }
//             if (typeof dto.ftpInfo !== "undefined") {
//                 this.ftpInfo = new EditReportFtpInfoModel(dto.ftpInfo);
//             }
//             if (typeof dto.fullDisplayText !== "undefined") {
//                 this.fullDisplayText = dto.fullDisplayText;
//             }
//         }
//     }

//     public toDTO(): IEditReportDeliveryDTO {
//         return {
//             id: this.id,
//             emailSubject: this.emailSubject,
//             emailBody: this.emailBody,
//             address: this.address,
//             deliveryType: this.deliveryType,
//             isDeleted: this.isDeleted,
//             isModified: this.isModified,
//             fullDisplayText: this.fullDisplayText
//         }
//     }
// }

// export class EditReportFtpInfoModel implements IEquatable<number>
// {
//     public id: number;

//     public get equatableKey(): number {
//         return this.id;
//     }

//     constructor(dto?: IEditReportFTPInfoDTO) {
//         if (dto) {
//             if (typeof dto.id !== "undefined") {
//                 this.id = dto.id;
//             }
//         }
//     }

//     public toDTO(): IEditReportFTPInfoDTO {
//         return {
//             id: this.id
//         };
//     }
// }

// export class ReportScheduleAdminUtilties {
//     public static devInfoEmail = "devinfo@elynxtech.com";    
//     public static hiddenRecipients: linqjs.IDictionary<string, string> = Enumerable.from(new Array<string>(ReportScheduleAdminUtilties.devInfoEmail, "reports@elynxtech.com")).toDictionary(o => o);

//     public static showEmailRecipient(address: string, isElynxAdmin: boolean) {
//         return isElynxAdmin || !ReportScheduleAdminUtilties.hiddenRecipients.contains(address.toLowerCase());
//     }    

//     public static getScheduleSummary(frequency: DRCX.DateRangeType, dayOfMonth: number, dayOfWeek: number, hour: number, minute: number, timezone: string, repeatFrequency: number = 1, repeatInterval: number = 1, month: number = 1) {
//         // only using this for the hour:minute portion of the datetime
//         const timeValue: moment.Moment = moment().hour(hour).minute(minute);
//         if (frequency == 99) {
//             frequency = repeatFrequency;
//             switch (frequency) {
//                 case DRCX.DateRangeType.Year:
//                     return [
//                         i18n.t("reportScheduleAdmin.steps.details.custom"),
//                         repeatInterval,
//                         i18n.t("reportScheduleAdmin.steps.details.year") + "(s)",
//                         i18n.t("reportScheduleAdmin.steps.details.at"),
//                         timeValue.format('h:mm A'),
//                         timezone
//                    ].join(" ");
//                 case DRCX.DateRangeType.Month:
//                     return [
//                         i18n.t("reportScheduleAdmin.steps.details.custom"),
//                         repeatInterval,
//                         i18n.t("reportScheduleAdmin.steps.details.month") + "(s)",
//                         i18n.t("reportScheduleAdmin.steps.details.at"),
//                         timeValue.format('h:mm A'),
//                         timezone
//                    ].join(" ");
//                 case DRCX.DateRangeType.Week:
//                     return [
//                         i18n.t("reportScheduleAdmin.steps.details.custom"),
//                         repeatInterval,
//                         i18n.t("reportScheduleAdmin.steps.details.week") + "(s)",
//                         i18n.t("reportScheduleAdmin.steps.details.at"),
//                         timeValue.format('h:mm A'),
//                         timezone
//                     ].join(" ");
//                 case DRCX.DateRangeType.Day:
//                     return [
//                         i18n.t("reportScheduleAdmin.steps.details.custom"),
//                         repeatInterval,
//                         i18n.t("reportScheduleAdmin.steps.details.day") + "(s)",
//                         i18n.t("reportScheduleAdmin.steps.details.at"),
//                         timeValue.format('h:mm A'),
//                         timezone
//                     ].join(" ");
//                 case DRCX.DateRangeType.Hour:
//                     return [
//                         i18n.t("reportScheduleAdmin.steps.details.custom"),
//                         repeatInterval,
//                         i18n.t("reportScheduleAdmin.steps.details.hour") + "(s)",
//                         i18n.t("reportScheduleAdmin.steps.details.at"),
//                         timeValue.format('h:mm A'),
//                         timezone
//                     ].join(" ")
//                 case DRCX.DateRangeType.Minute:
//                     return [
//                        i18n.t("reportScheduleAdmin.steps.details.custom"),
//                         repeatInterval,
//                         i18n.t("reportScheduleAdmin.steps.details.minute") + "(s)",
//                         timezone
//                     ].join(" ");
//             }
//         }
//         else {
//             var magicalSAppend = repeatInterval == 1 ? "" : "s"
//             switch (frequency) {
//             case DRCX.DateRangeType.Year:              
//                return [
//                    i18n.t("reportScheduleAdmin.steps.details.custom"),
//                    repeatInterval,
//                    i18n.t("reportScheduleAdmin.steps.details.year") + "(s)",
//                    i18n.t("reportScheduleAdmin.steps.details.on"),
//                    i18n.t("reportScheduleAdmin.steps.details.of"),
//                    month.toString() +"/" +dayOfMonth.toString(),
//                    i18n.t("reportScheduleAdmin.steps.details.at"),
//                    timeValue.format('h:mm A'),
//                    timezone
//               ].join(" ");
//             case DRCX.DateRangeType.Month:
//                 return [
//                     i18n.t("reportScheduleAdmin.steps.details.runReportOnDay"),
//                     dayOfMonth.toString(),
//                     i18n.t("reportScheduleAdmin.steps.details.ofThe"),
//                     i18n.t("reportScheduleAdmin.steps.details.month"),
//                     i18n.t("every"),
//                     repeatInterval == 1 ? "": repeatInterval,
//                     i18n.t("reportScheduleAdmin.steps.details.month") + magicalSAppend,
//                     i18n.t("reportScheduleAdmin.steps.details.at"),
//                     timeValue.format('h:mm A'),
//                     timezone
//                 ].join(" ");                
//             case DRCX.DateRangeType.Week:
//                 return [
//                     i18n.t("reportScheduleAdmin.steps.details.runReportEvery"),
//                     repeatInterval == 1 ? "": repeatInterval,
//                     moment.weekdays(dayOfWeek) + magicalSAppend, 
//                     i18n.t("reportScheduleAdmin.steps.details.at"),
//                     timeValue.format('h:mm A'),
//                     timezone
//                 ].join(" ");
//             case DRCX.DateRangeType.Day:
//                 return [
//                     i18n.t("reportScheduleAdmin.steps.details.runReportEvery"),
//                     repeatInterval == 1 ? "": repeatInterval,
//                     i18n.t("reportScheduleAdmin.steps.details.day") + magicalSAppend,
//                     i18n.t("reportScheduleAdmin.steps.details.at"),
//                     timeValue.format('h:mm A'),
//                     timezone
//                 ].join(" ");                
//             case DRCX.DateRangeType.Hour:
//                 return [
//                     i18n.t("reportScheduleAdmin.steps.details.runReportEvery"),
//                     repeatInterval == 1 ? "": repeatInterval,
//                     i18n.t("reportScheduleAdmin.steps.details.hour") + magicalSAppend,
//                     i18n.t("reportScheduleAdmin.steps.details.at"),
//                     minute,
//                     i18n.t("reportScheduleAdmin.steps.details.minutesPastTheHour"),
//                     "in",
//                     timezone
//                 ].join(" ");
//             case DRCX.DateRangeType.Minute:
//                     return [
//                        i18n.t("reportScheduleAdmin.steps.details.custom"),
//                         repeatInterval,
//                         i18n.t("reportScheduleAdmin.steps.details.minute") + "(s)",
//                         timeValue.format('h:mm A'),
//                         timezone
//                     ].join(" ");
//         }

//         return "Unknown frequency";
//         }
                   
//     }

//     public static getScheduleTypeFilterOptions(): Array<SelectOption> {
//         return [
//             new SelectOption(
//                 ReportScheduleTypeSelectionEnum.All,
//                 ReportScheduleTypeSelectionEnum.All.toString(),
//                 i18n.t("reportScheduleAdmin.filterTypes.all")
//             ),
//             new SelectOption(
//                 ReportScheduleTypeSelectionEnum.Custom,
//                 ReportScheduleTypeSelectionEnum.Custom.toString(),
//                 i18n.t("reportScheduleAdmin.filterTypes.custom")
//             ),
//             new SelectOption(
//                 ReportScheduleTypeSelectionEnum.GroupMarketing,
//                 ReportScheduleTypeSelectionEnum.GroupMarketing.toString(),
//                 i18n.t("reportScheduleAdmin.filterTypes.groupMarketing")
//             ),
//             //{
//             //    value: ReportScheduleTypeSelectionEnum.QuickTrend.toString(),
//             //    text: i18n.t("reportScheduleAdmin.filterTypes.quickTrend")
//             //},
//             new SelectOption(
//                 ReportScheduleTypeSelectionEnum.User,
//                 ReportScheduleTypeSelectionEnum.User.toString(),
//                 i18n.t("reportScheduleAdmin.filterTypes.user")
//             ),
//         ];
//     }

//     public static getScheduleTypeOptions(): Array<SelectOption> {
//         return [
//             new SelectOption(
//                 ReportTypeEnum.Custom,
//                 ReportTypeEnum.Custom.toString(),
//                 i18n.t("reportScheduleAdmin.reportTypes.custom")
//             ),
//             new SelectOption(
//                 ReportTypeEnum.GroupMarketing,
//                 ReportTypeEnum.GroupMarketing.toString(),
//                 i18n.t("reportScheduleAdmin.reportTypes.groupMarketing")
//             ),
//             //{
//             //    value: ReportScheduleModels.ReportTypeEnum.QuickTrend.toString(),
//             //    text: i18n.t("reportScheduleAdmin.reportTypes.quickTrend")
//             //},
//             new SelectOption(
//                 ReportTypeEnum.User,
//                 ReportTypeEnum.User.toString(),
//                 i18n.t("reportScheduleAdmin.reportTypes.user")
//             ),
//         ];
//     }

//     public static getScheduleFrequencyOptions(): Array<SelectOption> {
//         return [
//             new SelectOption(
//                 DRCX.DateRangeType.Month,
//                 DRCX.DateRangeType.Month.toString(),
//                 i18n.t("reportScheduleAdmin.reportFrequencyTypes.monthly")
//             ),
//             new SelectOption(
//                 DRCX.DateRangeType.Week,
//                 DRCX.DateRangeType.Week.toString(),
//                 i18n.t("reportScheduleAdmin.reportFrequencyTypes.weekly")
//             ),
//             new SelectOption(
//                 DRCX.DateRangeType.Day,
//                 DRCX.DateRangeType.Day.toString(),
//                 i18n.t("reportScheduleAdmin.reportFrequencyTypes.daily")
//             ),
//             new SelectOption(
//                 DRCX.DateRangeType.Hour,
//                 DRCX.DateRangeType.Hour.toString(),
//                 i18n.t("reportScheduleAdmin.reportFrequencyTypes.hourly")
//             ),
//             new SelectOption(
//                 99,
//                 "Custom",
//                 "Custom"
//             )
//         ];
//     }
//     public static getScheduleFrequencyDropdownOptions(): Array<SelectOption> {
//         return [
//            new SelectOption(
//                DRCX.DateRangeType.Year,
//                DRCX.DateRangeType.Year.toString(),
//                i18n.t("Year(s)"),
//                true
//            ),
//            new SelectOption(
//                DRCX.DateRangeType.Month,
//                DRCX.DateRangeType.Month.toString(),
//                i18n.t("Month(s)")
//            ),

//           new SelectOption(
//               DRCX.DateRangeType.Week,
//               DRCX.DateRangeType.Week.toString(),
//               i18n.t("Week(s)")
//           ),

//           new SelectOption(
//                DRCX.DateRangeType.Day,
//                DRCX.DateRangeType.Day.toString(),
//                i18n.t("Day(s)")
//           ),

//           new SelectOption(
//               DRCX.DateRangeType.Hour,
//               DRCX.DateRangeType.Hour.toString(),
//               i18n.t("Hour(s)")
//           ),

//           new SelectOption(
//               DRCX.DateRangeType.Minute,
//               DRCX.DateRangeType.Minute.toString(),
//               i18n.t("Minute(s)")
//           )
//         ];
//     }

//     public static getExportTypeOptions(includeCustom: boolean): Array<SelectOption> {
//         let options: Array<SelectOption> = [
//             new SelectOption(
//                 ExportFormatTypeEnum.Excel,
//                 ExportFormatTypeEnum.Excel.toString(),
//                 i18n.t("reportScheduleAdmin.exportTypes.excel"),
//                 false,
//                 true
//             ),
//             new SelectOption(
//                 ExportFormatTypeEnum.Pdf,
//                 ExportFormatTypeEnum.Pdf.toString(),
//                 i18n.t("reportScheduleAdmin.exportTypes.pdf"),
//                  false,
//                  true
//             ),
//             new SelectOption(
//                 ExportFormatTypeEnum.Csv,
//                 ExportFormatTypeEnum.Csv.toString(),
//                 i18n.t("reportScheduleAdmin.exportTypes.csv"),
//                 false,
//                 true
//             ),
//          ];

//         if (includeCustom === true) {
//             options.push(new SelectOption(
//                 ExportFormatTypeEnum.Custom,
//                 "Other",
//                 i18n.t("Other"),
//                 false,
//                 false
//             ));
//         }

//         return options;
            
//     }

//     public static getDayOfMonthOptions(): Array<SelectOption> {
//         return Enumerable.range(1, 31, 1)
//             .select(o => new SelectOption(
//                 o,
//                 o.toString(),
//                 o.toString()
//             ))
//             .toArray();
//     }

//     public static getDayOfWeekOptions(): Array<SelectOption> {
//         return [
//             new SelectOption(
//                 0,
//                 "0",
//                 "Sunday"
//             ),
//             new SelectOption(
//                 1,
//                 "1",
//                 "Monday"
//             ),
//             new SelectOption(
//                 2,
//                 "2",
//                 "Tuesday"
//             ),
//             new SelectOption(
//                 3,
//                 "3",
//                 "Wednesday"
//             ),
//             new SelectOption(
//                 4,
//                 "4",
//                 "Thursday"
//             ),
//             new SelectOption(
//                 5,
//                 "5",
//                 "Friday"
//             ),
//             new SelectOption(
//                 6,
//                 "6",
//                 "Saturday"
//             )
//         ];
//     }

//     // public static getHourOptions(): Array<SelectOption> {
//     //     return Enumerable.range(0, 24, 1)
//     //         .select(o => new SelectOption(
//     //             o,
//     //             o.toString(),
//     //             this.leadingZeros(o)
//     //         ))
//     //         .toArray();
//     // }

//     // public static getMinuteOptions(): Array<SelectOption> {
//     //     return Enumerable.range(0, 60, 1)
//     //         .select(o => new SelectOption(
//     //             o,
//     //             o.toString(),
//     //             this.leadingZeros(o)
//     //         ))
//     //         .toArray();
//     // }

//     // public static leadingZeros = (value: number) => {
//     //     const s = "00" + value.toString();
//     //     return s.substr(s.length - 2);
//     // }
// }

export interface IAvailableNotificationListDTO {
    dt: string;
    id: number;
    oid: number;
}

export interface IAvailableRecipientDTO {
    dt: string;
    id: number;
    oid: number;
    tid: number;
    uid: number;
    udt: string;
    ud: boolean;
}

export interface IAvailableNotificationInfoDTO {
    notificationLists: IAvailableNotificationListDTO[];
    recipients: IAvailableRecipientDTO[];
}


export interface IDeleteDeliveryModel
{
    deliveryIDs: number[]
}


export interface ISendReportModel {
    organizationId: number;
    configurationId: number;
    startDate: Date | undefined;
    endDate: Date | undefined;
    includeSubGroups: boolean;
    documentType: ApplicationMimeTypesEnum;
}